module.exports = __webpack_public_path__ + "static/media/info-btn-4.f059183d.jpg";